export default __webpack_public_path__ + "static/N0248-eb189dca4da47de3fc6b6a149bb43461.png";